module.exports = __webpack_public_path__ + "static/img/xi_12.b489214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_12.jpg
// module id = rxnq
// module chunks = 1